import React from "react";
import "./AboutUs.css";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaHeartbeat,
  FaLeaf,
  FaUsers,
FaGopuram as FaTemple,  FaShoppingBag,
  FaWater,
  FaClock,
  FaHospital,
  FaHome,
  FaTree,
  FaBus,
} from "react-icons/fa";

const AboutAll = () => {
  return (
    <div className="aboutall-page">
      {/* HERO SECTION */}
      <header className="hero">
        <div className="hero-overlay" />
        <div className="hero-inner">
          <h1>Nimgaon Ketaki</h1>
          <p className="hero-sub">
            A village rooted in devotion, culture, and agricultural heritage — located in Indapur taluka, Maharashtra.
          </p>
          <div className="hero-meta">
            <div className="meta-item">
              <FaMapMarkerAlt />
              <span>12 km from Indapur (Indapur–Pune Hwy)</span>
            </div>
            <div className="meta-item">
              <FaUsers />
              <span>Population ≈ 20,000</span>
            </div>
            <div className="meta-item">
              <FaLeaf />
              <span>Famous for Nagveli (betel leaf)</span>
            </div>
          </div>
        </div>
      </header>

      {/* MAIN CONTAINER */}
      <main className="container">
        {/* INTRO SECTION */}
        <section className="card intro-card">
          <div className="intro-grid">
            <div className="intro-text">
              <h2>About Nimgaon Ketaki</h2>
              <p>
                Nimgaon Ketaki derives its name from the Ketaki bushes that once thrived here. While working in these bushes, villagers discovered an ancient Shivalinga — the heart of the village's spiritual identity. Historically granted as <em>mukas</em> to Naik Nimbalkar, the village has a rich cultural and agricultural heritage.
              </p>
              <ul className="quick-facts">
                <li><strong>Wadis:</strong> 12</li>
                <li><strong>Hamlets in region:</strong> 36</li>
                <li><strong>Highways:</strong> Indapur–Pune & Indapur–Baramati</li>
                <li><strong>Renovation (temple):</strong> 1859–1862</li>
              </ul>
            </div>
            <div className="intro-gallery">
              <img src="./images/temple1.jpg" alt="Nimgaon Ketaki scenic" />
              <img src="./images/temple2.jpg" alt="Traditional homes" />
              <img src="./images/ketkeshvar4.jpg" alt="Festival celebration" />
            </div>
          </div>
        </section>

        {/* TEMPLES & FESTIVALS SECTION */}
        <section className="card section-block">
          <div className="section-header">
            <FaTemple className="section-icon" />
            <h3>Temples & Festivals</h3>
          </div>
          <div className="two-col">
            <div className="temple-card">
              <img src="./images/temple1.jpg" alt="Shri Ketakeshwar Mahadev Mandir" />
              <div className="temple-body">
                <h4>Shri Ketakeshwar Mahadev Mandir</h4>
                <p className="muted">The spiritual heart of Nimgaon Ketaki</p>
                <ul>
                  <li>Ancient Shivalinga discovered in Ketaki bushes</li>
                  <li>Main site for <strong>Chaitri Ekadashi Yatra</strong></li>
                  <li>Chikhle family maintains the Shivlinga</li>
                  <li>Chariot pulled by the Matang community</li>
                </ul>
              </div>
            </div>
            <div className="temple-card">
              <img src="./images/temple2.jpg" alt="Suvarnayug Ganesh Mandir" />
              <div className="temple-body">
                <h4>Suvarnayug Ganesh Mandir</h4>
                <p className="muted">Managed by Suvarnayug Trust</p>
                <ul>
                  <li>Famous 2-day Ganesh Yatra: <strong>25–26 Dec</strong></li>
                  <li>Bhajans, processions, and youth-led events</li>
                  <li>Peaceful environment for prayer & cultural programs</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="festival-notes">
            <h5>Chaitri Ekadashi Yatra — 3 days</h5>
            <p>
              Day 1: Grand chariot procession. Day 2: Palkhi & Chhabina. Day 3: Jangi Nikali wrestling arena hosting famous wrestlers and local champions.
            </p>
          </div>
        </section>

        {/* MARKETS & ECONOMY SECTION */}
        <section className="card section-block">
          <div className="section-header">
            <FaShoppingBag className="section-icon" />
            <h3>Markets & Economy</h3>
          </div>
          <div className="market-grid">
            <div className="market-card">
              <img src="./images/leaf1.jpg" alt="Leaf Market" />
              <div className="market-body">
                <h4>Leaf Market (पान बाजार)</h4>
                <p className="muted">Every Tuesday — near Gram Panchayat Office</p>
                <ul>
                  <li>Wholesale & retail betel leaves (Nagveli)</li>
                  <li>Supplies regional vendors and traders</li>
                </ul>
              </div>
            </div>
            <div className="market-card">
              <img src="./images/weekly1.jpg" alt="Weekly Market" />
              <div className="market-body">
                <h4>Weekly Market (साप्ताहिक बाजार)</h4>
                <p className="muted">Every Saturday — near Gram Panchayat Office</p>
                <ul>
                  <li>Vegetables, fruits, cereals, clothing, utensils</li>
                  <li>Street food & entertainment till sunset</li>
                </ul>
              </div>
            </div>
            <div className="economy-card">
              <h4>Economy & Employment</h4>
              <p>Nimgaon Ketaki’s economy is agriculture-driven with growing trade and small industries.</p>
              <ul>
                <li>Principal crop: Nagveli (betel leaf)</li>
                <li>Temple tourism & retail shops</li>
                <li>Construction, dairying & sugar mills nearby</li>
                <li>Cooperative societies supporting growth</li>
              </ul>
            </div>
          </div>
        </section>

        {/* HEALTHCARE SECTION */}
        <section className="card section-block">
          <div className="section-header">
            <FaHospital className="section-icon" />
            <h3>Primary Health Center</h3>
          </div>
          <div className="phc-grid">
            <div className="phc-image">
              <img src="./images/healthcare.jpg" alt="Primary Health Center" />
            </div>
            <div className="phc-info">
              <h4>Primary Health Center, Nimgaon Ketaki</h4>
              <p className="muted">Rural Government Hospital — Near Gram Panchayat Office</p>
              <p className="contact">
                <FaPhoneAlt /> <a href="tel:+919876543210">+91-9876543210</a>
              </p>
              <h5>Available Services</h5>
              <ul>
                <li>OPD & General Consultation</li>
                <li>Maternal & Child Health Services</li>
                <li>Vaccination & Immunization</li>
                <li>BP & Sugar Check-up</li>
                <li>Free Generic Medicines</li>
                <li>Basic Lab Testing</li>
                <li>Emergency First Aid & Referrals</li>
              </ul>
              <h5>How to Avail Services</h5>
              <ol>
                <li>Visit & register at OPD</li>
                <li>Consult doctor or health worker</li>
                <li>Get tests done if required</li>
                <li>Collect free medicines</li>
                <li>Referral if advanced care needed</li>
              </ol>
            </div>
          </div>
        </section>

        {/* FACILITIES SECTION */}
        <section className="card section-block">
          <div className="section-header">
            <FaHome className="section-icon" />
            <h3>Village Facilities</h3>
          </div>
          <div className="facilities-grid">
            <div className="facility">
              <FaMapMarkerAlt />
              <div>
                <h6>Gram Panchayat</h6>
                <p className="muted">Local governance & community services</p>
              </div>
            </div>
            <div className="facility">
              <FaHospital />
              <div>
                <h6>Primary Health Center</h6>
                <p className="muted">Medical & emergency services</p>
              </div>
            </div>
            <div className="facility">
              <FaLeaf />
              <div>
                <h6>Agricultural Market</h6>
                <p className="muted">Produce market & livestock trading</p>
              </div>
            </div>
            <div className="facility">
              <FaBus />
              <div>
                <h6>Transport & Connectivity</h6>
                <p className="muted">State highway connectivity & public transport</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="card contact-cta">
          <div>
            <h3>Want to add more details or images?</h3>
            <p className="muted">Send images or text — page and memory will be updated.</p>
          </div>
          <div className="cta-actions">
            <a className="btn" href="/contact">Contact Gram Panchayat</a>
            <a className="btn-outline" href="/about">Full About Page</a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutAll;
